import React from "react";
import { Link } from "react-router-dom";

import "../../utilities.css"
import "./AllComms.css";

import default_img_src from "../../img/logo/wcr_official_logo.png";

import { scrollToTop } from "../../utilities.js";

const AllComms = ({commArr}) => {
  return (
    <div className="AllComms-container">
      { 
        commArr.map(
          (comm) => { 
          let bG
          if (comm.profile.profilePicture) {
            bG = `url("${comm.profile.profilePicture.url}")`;
          } else {
            bG = `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url("${default_img_src}")`;
          }

          return (
            <div key={comm.id} className="AllComms-single">
              {comm.profile.display ? 
                <Link to={`/profile/${comm.profile.username}`} onClick={scrollToTop}>
                  <div className="AllComms-background" style={{backgroundImage: bG}}> </div>
                  <div className="AllComms-about"> 
                      <div className="AllComms-name"> <b>{comm.profile.preferredName}</b></div>
                      <div className="AllComms-post"> {comm.committee_post.name} </div>
                  </div>
                </Link> : <div>
                    <div className="AllComms-background" style={{backgroundImage: bG}}> </div>
                    <div className="AllComms-about"> 
                        <div className="AllComms-name"> <b>{comm.profile.preferredName}</b></div>
                        <div className="AllComms-post"> {comm.committee_post.name} </div>
                    </div>
                  </div>}
            </div>
          )
        })}
    </div>
  );
};
  
export default AllComms;